import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportHostTasks = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `host-task-report/tasks/details?${queries}` });

  return data?.data;
};

export default getReportHostTasks;
